import React from 'react'
import Link from '../../utils/link'

import { Phone, Email } from '../icons'
import ArrowRight from '../../assets/images/arrow-right.svg'

const AgentCard = (props) => {
  return (
    <div className='card card--agent'>
      <div className='card__image'>
        { props.image?.sourceUrl && <img src={props.image.sourceUrl} alt={props.title} /> }
      </div>
      <div className='card__content'>
        <h4>{props.title}</h4>
        <span className='card__role'>{props.role}</span>
        <h5>{props.office.title}</h5>
        <ul className='card__social'>
          <li>
            <Link to={`tel:${props.phone}`}>
              <Phone color={'#1c1c1c'} />
              <span>{props.phone}</span>
            </Link>
          </li>
          <li>
            <Link to={`mailto:${props.email}`}>
              <Email color={'#1c1c1c'} />
              <span>Email</span>
            </Link>
          </li>
        </ul>
      </div>
      <span className='card__button'>Profile <img src={ArrowRight} alt='View Profile' /></span>
      <Link className='card__link' to={props.link}></Link>
    </div>
  )
}

export default AgentCard